import Style from "../components/StartNew.module.css"
import StyleMentors from "../components/Mentors.module.css"
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import React, {useEffect, useState} from "react";
import ReactGA from "react-ga4";
import {getMentors, verifyLogin} from "../api/UserService";
import {useNavigate} from "react-router-dom";
import MentorsCard from "./MentorsCard";
import InstagramWarning from "./InstagramWarning";

function Mentors(props) {
    const [authorised, setAuthorised] = useState(false)
    const [loginVerificationComplete, setLoginVerificationComplete] = useState(false)
    const [mentors, setMentors] = useState()
    const nav = useNavigate()

    useEffect(() => {
            verifyLogin(onLoginVerify)
            getMentors(setMentors, () => {
            })
        },
        [])

    function onLoginVerify(authorised) {
        setAuthorised(authorised)
        setLoginVerificationComplete(true)
    }

    function sendEvent(action, category) {
        ReactGA.event({
            action: action,
            category: category,
            label: "Start page"
        })
    }

    function verifyLoggedIn() {
        return loginVerificationComplete && authorised
    }

    function renderTooltip(text) {
        return (<Tooltip id="button-tooltip">
            {text}
        </Tooltip>)
    }


    return (
        <>
            <InstagramWarning/>
            <div className={Style.startPageMainContainer}>
                <div className={Style.upperNavBar}>
                    <span onClick={() => nav("/")} className={Style.logoText}
                    >LeelaOnline
                    </span>
                    <div className={Style.prices} onClick={() => sendEvent("open prices", "prices")}>
                        <a href={"https://leelaonline.net/price"} target="_blank">Ціни</a>
                    </div>
                    <div className={Style.videos} onClick={() => sendEvent("open videos", "videos")}>
                        <a href={"https://www.youtube.com/playlist?list=PLXzFMjHpPAd0oyUx8gCJI4kOBmyq-KNGR"}
                           target="_blank">Як користуватись</a>
                    </div>
                    <div className={Style.loginButton}>
                        <OverlayTrigger
                            placement="bottom"
                            delay={{show: 50, hide: 400}}
                            overlay={renderTooltip(verifyLoggedIn() ? "Мій кабінет" : "Увійти / Зареєструватись")}
                        >
                            <AccountCircleIcon
                                style={{
                                    fontSize: "xx-large",
                                    backgroundColor: verifyLoggedIn() ? "#7DA98D" : "white",
                                    borderRadius: "35px"
                                }}
                                onClick={() => {
                                    if (!verifyLoggedIn()) {
                                        nav("/login")
                                    }
                                    if (verifyLoggedIn()) {
                                        nav("/mentor/cabinet")
                                    }
                                }}>
                            </AccountCircleIcon>
                        </OverlayTrigger>
                    </div>
                </div>
                <div className={StyleMentors.topContainer}>
                    {mentors?.map(mentor => {
                        return (
                            <MentorsCard
                                key={mentor.id}
                                id={mentor.id}
                                name={mentor.nickname}
                                photoLink={mentor.photo_url}
                                shortBio={mentor.short_bio}
                                longBio={mentor.long_bio}
                                instagram={mentor.social_url}/>
                        )
                    })}
                </div>
            </div>
        </>

    )
}

export default Mentors;